import urn from "./urn";
import mus from "./mus";
import onk from "./onk";
import sat from "./sat";
import rdv from "./rdv";
import stu from "./stu";
import dyt from "./dyt";
import tkl from "./tkl";
import dst from "./dst";
import blg from "./blg";
import ibs from "./ibs";

// Tüm süreçlerin turları tek sözlükte: anahtar → { yol, adimlar }. Yeni süreç planı kendi
// dosyasını ekleyip buraya yayar. Madde kodu → tur anahtarı eşlemesi MADDE_TURU'nda.
export const TURLAR = { ...urn, ...mus, ...onk, ...sat, ...rdv, ...stu, ...dyt, ...tkl, ...dst, ...blg, ...ibs };

// Başlarken maddesine tıklanınca hangi tur açılır (BSL-URN §5 «Hangi madde hangi turu açar»).
export const MADDE_TURU = {
  "URN-URUN": "yeniUrun",
  "URN-GIRIS": "urunGiris",
  "MUS-ILK": "yeniMusteri",
  "MUS-YUKLE": "musteriToplu",
  "ONK-PAYLAS": "onkayitPaylas",
  "ONK-YANIT": "onkayitListesi",
  "SAT-ILK": "urunSatis",
  "SAT-TAHSIL": "musteriHesap",
  "RDV-SAAT": "randevuSaat",
  "RDV-TIP": "randevuTip",
  "RDV-ILK": "randevuTakvim",
  "RDV-ONLINE": "randevuPaylas",
  "STU-SAAT": "studioSaat",
  "STU-EGITMEN": "studioEgitmen",
  "STU-PAKET": "studioPaket",
  "STU-DERS": "studioDersYeni",
  "STU-SATIS": "urunSatis",
  "STU-YOKLAMA": "studioYoklama",
  "DYT-PAKET": "dytPaket",
  "DYT-DANISAN": "dytDanisan",
  "DYT-PLAN": "dytPlan",
  "DYT-OLCUM": "dytOlcum",
  "TKL-KURAL": "teklifKural",
  "TKL-TEKLIF": "teklifOlustur",
  "TKL-GONDER": "teklifListe",
  "TKL-TALEP": "talepPaylas",
  "DST-KATEGORI": "ymKategori",
  "DST-SLA": "slaKural",
  "DST-PAYLAS": "cagriPaylas",
  "DST-YANIT": "cagriUstlen", // BSL-D2 (B-11): göreve özel tur (sayfa turu cagriListe ? menüsünde kalır)
  "BLG-YAZI": "blogYeni",
  "BLG-YAYIN": "blogYayin",
  "BLG-KOLEKSIYON": "blogKoleksiyon",
  "IBS-BILGI": "isletmeBilgi",
};

// Madde bir sayfa penceresini de açtırıyorsa (BSL-MUS §3: MUS-YUKLE → Toplu Yükle penceresi).
export const MADDE_PENCERE = {
  "MUS-YUKLE": "musteriToplu",
  "ONK-PAYLAS": "onkayitPaylas",
  "RDV-ONLINE": "randevuPaylas",
  "STU-YOKLAMA": "studioYoklama",
  "DYT-PLAN": "dytPlan",
  "DYT-OLCUM": "dytOlcum",
  "TKL-GONDER": "teklifGonder", // Teklif Listesi kullanıcının son taslağını açar (tur: teklifDetay)
  "TKL-TALEP": "talepPaylas",
  "DST-PAYLAS": "cagriPaylas",
};

// ? menüsü «Bu ekranı tanıt»: route yoluna göre tur (tam eşleşme). Aynı yolda birden çok tur varsa
// (Randevu Ayarları sekmeleri) dom=true ile tıklama anında hedefi görünen tur seçilir; `oncelik`li tur
// (BSL-STU: Yeni Ürün'de Studio paketi alanları) hedefi görünüyorsa öne geçer.
// BSL-BLG: tur yolu `:id` gibi parametre parçası içerebilir (/blog/duzenle/:id); o parça her değerle eşleşir.
export function yolEsit(desen, yol) {
  const a = (desen || "").toLowerCase().split("/");
  const b = (yol || "").split("?")[0].toLowerCase().split("/");
  return a.length === b.length && a.every((s, i) => (s.startsWith(":") ? !!b[i] : s === b[i]));
}

export function yolunTuru(yol, dom = false) {
  const adaylar = Object.keys(TURLAR).filter((k) => !TURLAR[k].pencere && yolEsit(TURLAR[k].yol, yol));
  if (dom && adaylar.length > 1) {
    const sirali = adaylar.slice().sort((a, b) => (TURLAR[b].oncelik ? 1 : 0) - (TURLAR[a].oncelik ? 1 : 0));
    // BSL-D2 (B-9): yalnız ilk balonunun hedefi görünen tur seçilir (her sekmede görünen sekme başlığı
    // başka sekmenin turunu seçtirmesin); hiçbiri görünmüyorsa sekmenin turu yok → null.
    return sirali.find((k) => {
      const a = TURLAR[k].adimlar[0];
      return a && [].concat(a.hedef).some((h) => {
        const el = document.querySelector(h);
        return el && el.getClientRects().length > 0;
      });
    }) || null;
  }
  return adaylar[0] || null;
}
